// extracted by mini-css-extract-plugin
export default {"tableTitle":"show-class-results_modal_tableTitle__WI4Dh"};